/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Garden_AreaInputs */

const cs_form_garden_area = /** @type {(inputs: Form_Garden_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahrada (m²)`)
};

const en_form_garden_area = /** @type {(inputs: Form_Garden_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garden area (m²)`)
};

/**
* | output |
* | --- |
* | "Garden area (m²)" |
*
* @param {Form_Garden_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_garden_area = /** @type {((inputs?: Form_Garden_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Garden_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_garden_area(inputs)
	return cs_form_garden_area(inputs)
});